import { TOUR_TRANSLATIONS } from "../translations"

export const getPriceEvolutionSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="price-evolution-filters"]',
            title: t.priceEvolutionFilters.title,
            content: t.priceEvolutionFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="price-evolution-tabs"]',
            title: t.priceEvolutionTabs.title,
            content: t.priceEvolutionTabs.content,
        },
        {
            target: '[data-tour="price-evolution-widget"]',
            title: t.priceEvolutionWidget.title,
            content: t.priceEvolutionWidget.content,
        },
        {
            target: '[data-tour="price-evolution-chart"]',
            title: t.priceEvolutionChart.title,
            content: t.priceEvolutionChart.content,
        },
        {
            target: '[data-tour="price-evolution-table"]',
            title: t.priceEvolutionTable.title,
            content: t.priceEvolutionTable.content,
        },
    ]
}
